export const trPrimeVue = {
  startsWith: 'Ile baslar',
  contains: 'Icerir',
  notContains: 'Icermez',
  endsWith: 'Ile biter',
  equals: 'Esittir',
  notEquals: 'Esit degildir',
  noFilter: 'Filtresiz',
  lt: 'Kucuktur',
  lte: 'Kucuk veya esittir',
  gt: 'Buyuktur',
  gte: 'Buyuk veya esittir',
  dateIs: 'Tarih esittir',
  dateIsNot: 'Tarih esit degildir',
  dateBefore: 'Tarihten once',
  dateAfter: 'Tarihten sonra',
  clear: 'Temizle',
  apply: 'Uygula',
  matchAll: 'Tumu eslesir',
  matchAny: 'Herhangi biri eslesir',
  addRule: 'Kural ekle',
  removeRule: 'Kural kaldir',
  accept: 'Evet',
  reject: 'Hayir',
  choose: 'Sec',
  upload: 'Yukle',
  cancel: 'Iptal',
  completed: 'Tamamlandi',
  pending: 'Beklemede',
  dayNames: ['Pazar', 'Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi'],
  dayNamesShort: ['Paz', 'Pts', 'Sal', 'Car', 'Per', 'Cum', 'Cts'],
  dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ca', 'Pe', 'Cu', 'Ct'],
  monthNames: [
    'Ocak',
    'Subat',
    'Mart',
    'Nisan',
    'Mayis',
    'Haziran',
    'Temmuz',
    'Agustos',
    'Eylul',
    'Ekim',
    'Kasim',
    'Aralik',
  ],
  monthNamesShort: [
    'Oca',
    'Sub',
    'Mar',
    'Nis',
    'May',
    'Haz',
    'Tem',
    'Agu',
    'Eyl',
    'Eki',
    'Kas',
    'Ara',
  ],
  chooseYear: 'Yil Sec',
  chooseMonth: 'Ay Sec',
  chooseDate: 'Tarih Sec',
  prevDecade: 'Onceki On Yil',
  nextDecade: 'Sonraki On Yil',
  prevYear: 'Onceki Yil',
  nextYear: 'Sonraki Yil',
  prevMonth: 'Onceki Ay',
  nextMonth: 'Sonraki Ay',
  prevHour: 'Onceki Saat',
  nextHour: 'Sonraki Saat',
  prevMinute: 'Onceki Dakika',
  nextMinute: 'Sonraki Dakika',
  prevSecond: 'Onceki Saniye',
  nextSecond: 'Sonraki Saniye',
  am: 'OO',
  pm: 'OS',
  today: 'Bugun',
  weekHeader: 'Hf',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd/mm/yy',
  weak: 'Zayif',
  medium: 'Orta',
  strong: 'Guclu',
  passwordPrompt: 'Sifre girin',
  emptyFilterMessage: 'Sonuc bulunamadi',
  searchMessage: '{0} sonuc mevcut',
  selectionMessage: '{0} oge secildi',
  emptySelectionMessage: 'Secili oge yok',
  emptySearchMessage: 'Sonuc bulunamadi',
  emptyMessage: 'Mevcut secenek yok',
  aria: {
    trueLabel: 'Dogru',
    falseLabel: 'Yanlis',
    nullLabel: 'Secili degil',
    star: '1 yildiz',
    stars: '{star} yildiz',
    selectAll: 'Tum ogeler secildi',
    unselectAll: 'Tum ogelerin secimi kaldirildi',
    close: 'Kapat',
    previous: 'Onceki',
    next: 'Sonraki',
    navigation: 'Navigasyon',
    scrollTop: 'En Uste Kaydir',
    moveTop: 'En Uste Tasi',
    moveUp: 'Yukari Tasi',
    moveDown: 'Asagi Tasi',
    moveBottom: 'En Alta Tasi',
    moveToTarget: 'Hedefe Tasi',
    moveToSource: 'Kaynaga Tasi',
    moveAllToTarget: 'Tumunu Hedefe Tasi',
    moveAllToSource: 'Tumunu Kaynaga Tasi',
    pageLabel: 'Sayfa {page}',
    firstPageLabel: 'Ilk Sayfa',
    lastPageLabel: 'Son Sayfa',
    nextPageLabel: 'Sonraki Sayfa',
    prevPageLabel: 'Onceki Sayfa',
    rowsPerPageLabel: 'Sayfa basina satir',
    jumpToPageDropdownLabel: 'Sayfaya Atla',
    jumpToPageInputLabel: 'Sayfaya Atla',
    selectRow: 'Satir Secildi',
    unselectRow: 'Satir Secimi Kaldirildi',
    expandRow: 'Satir Genisletildi',
    collapseRow: 'Satir Daraltildi',
    showFilterMenu: 'Filtre Menusunu Goster',
    hideFilterMenu: 'Filtre Menusunu Gizle',
    filterOperator: 'Filtre Operatoru',
    filterConstraint: 'Filtre Kisitlamasi',
    editRow: 'Satiri Duzenle',
    saveEdit: 'Duzenlemeyi Kaydet',
    cancelEdit: 'Duzenlemeyi Iptal Et',
    listView: 'Liste Gorunumu',
    gridView: 'Izgara Gorunumu',
    slide: 'Slayt',
    slideNumber: '{slideNumber}',
    zoomImage: 'Resmi Yakinlastir',
    zoomIn: 'Yakinlastir',
    zoomOut: 'Uzaklastir',
    rotateRight: 'Saga Dondur',
    rotateLeft: 'Sola Dondur',
  },
}
